import { render } from "./NcSpinner.vue?vue&type=template&id=2165763c&scoped=true"
import script from "./NcSpinner.vue?vue&type=script&lang=js"
export * from "./NcSpinner.vue?vue&type=script&lang=js"

import "./NcSpinner.vue?vue&type=style&index=0&id=2165763c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2165763c"]])

export default __exports__